import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import "./css/KitchenReg.css";
import 'bootstrap/dist/css/bootstrap.css';
import SideNav from './SideNav'
import TopRootDiv from './TopRootDiv';
import SherDineNav from './SherDineNav';
import { ToastContainer, toast } from 'react-toastify';
import Select, { components } from 'react-select';
import { DBContext } from './DBContext'
import axios from 'axios'

function SubKitchenReg() {

    const [collapsed, setCollapsed] = useState(false);
    const [SubKitchenName, setSubKitchenName] = useState("");
    const [KitchenCode, setKitchenCode] = useState("");
    const [Database, setDatabase] = useState(localStorage.getItem('DB'));
    const [imgCode, setImgCode] = useState(localStorage.getItem('imgCode'));
    const [company, setCompany] = useState(localStorage.getItem('Company'));
    const location = useLocation(null)

    const [subKitchenId,setSubKitchenId] = useState(null)
    const [subKitchen,setSubKitchen] = useState(null)

    useEffect(() => {
        if (location.state) {
            setSubKitchenId(location.state.id)
            setSubKitchen(location.state.kitchen)
        }
    },[location])

    const [item, setItem] = useState({})

    const toggleSidebar = () => {
        setCollapsed(!collapsed);
    };
    
    const api_base_url = process.env.REACT_APP_API_BASE_URL

    const { logginedDB } = useContext(DBContext);

    const [options,setOptions] = useState([])

    const handleModifyKitchen = async () => {
        try {
            const response = await axios.get(`${api_base_url}/getSubKitchenDetails/${subKitchenId}/${logginedDB}`)
            if (response.status == 200) {
                setSubKitchenName(response.data[0].SubKitchenName)
                // setKitchenCode(response.data[0].KitchenCode)
                //(response.data[0]);
                

                const selectedOption = options.find(option => option.value === response.data[0].KitchenCode);
                
                setSelectedOption(selectedOption);
                
            }
        } catch (error) {
            //(error);
        }
    }

    useEffect(() => {
        if (subKitchenId && options.length > 0) {
            handleModifyKitchen()
        }
    },[subKitchenId,options])
    
    const handleSubmit = async () => {
            if (!SubKitchenName || !selectedOption) {
                alert("Please fill in all fields.");
                return;
            }

            const data = {
                SubKitchenName: SubKitchenName,
                Kitchen: selectedOption.value
            };

            let response;

            try {
                //("Try");
                if (subKitchenId) {
                    response = await fetch(`${api_base_url}/SubKitchenRegUpdate/${subKitchenId}/${logginedDB}`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(data)
                    });
                } else {
                    response = await fetch(`${api_base_url}/SubKitchenReg/${logginedDB}`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(data)
                    });
                }   

                if (response.ok) {
                    //("Data submitted successfully");
                    toast.success("SubKitchen successully Registered",{
                        className: 'custom-toast',
                        bodyClassName: 'custom-toast-container',
                        closeButtonClassName: 'custom-toast-close-button',
                        onClose: () => {}
                    });
                    // Optionally, reset the form fields here
                    setSubKitchenName("");
                    navigate('/basemenureg', {
                        state: 'SubKitchenCancel'
                    })
                } else {
                    toast.error("SubKitchen Registered Failed. Please try again.",{
                        className: 'custom-toast',
                        bodyClassName: 'custom-toast-container',
                        closeButtonClassName: 'custom-toast-close-button',
                        onClose: () => {}
                    });
                    console.error("Failed to submit data");
                }
            } catch (error) {
                toast.error("SubKitchen Registered Failed. Please try again.",{
                    className: 'custom-toast',
                    bodyClassName: 'custom-toast-container',
                    closeButtonClassName: 'custom-toast-close-button',
                    onClose: () => {}
                });
                console.error("Error:", error);
            }
        }
    
    const handleSubKitchenNameChange = (event) => {
        setSubKitchenName(event.target.value);
    };
    
    useEffect(() => {
        const handleWindowResize = () => {
            if (window.innerWidth <= 768) {
                setCollapsed(true);
            } else {
                setCollapsed(false);
            }
        };

        window.addEventListener("resize", handleWindowResize);

        return () => {
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);


    const navigate = useNavigate();

    const handleCancel = () => {
        navigate('/basemenureg', {
            state: 'KitchenCancel'
        })
    }

    const handleGetKitchen = async () => {
        try {
            const response = await axios.get(`${api_base_url}/GetKitchen/${logginedDB}`)
            if (response.status == 200) {
                const transformedData = response.data.map(item => ({
                    value: item.KitchenCode, 
                    label: item.KitchenName, 
                }));
                
                setOptions(transformedData)
            }
        } catch (error) {
            //(error);
        }
    }

    useEffect(() => {
        handleGetKitchen()
    },[api_base_url])

    const [selectedOption,setSelectedOption] = useState(null)

    const customStyles = {
		option: (provided, state) => ({
			...provided,
			fontSize: '.9em',
			// fontFamily: 'Poppins',
			textAlign: 'left',
			backgroundColor: state.isSelected ? '#c8cbcf' : '#FFF',
			color: state.isFocused ? '#000' : '#000',
			cursor: 'pointer', // Add cursor pointer on hover
			':hover': {
				backgroundColor: '#c8cbcf',
				color: '#000',
			},
			':active': {
				...provided[':active'],
				backgroundColor: '#c8cbcf'
			}
		}),
		control: (provided, state) => ({
			...provided,
			width: '100%',
			// height: '2.5rem',
			minHeight: '2.6rem',
			fontSize: '1em',
			borderRadius: '.313rem', // Adjust this value as needed
			padding: '0', // Ensure no extra padding is added
			// border: 'none',
			// fontWeight: '500',
			// color: 'white !important', // Set text color to white
			backgroundColor: 'transparent', // Change this to 'transparent' for a clear background
			boxShadow: 'none', // Remove the blue focus shadow
			border: '1px solid #ccc',
			'&:hover': {
				borderBottom: '1px solid #c8cbcf', // Optional: border on hover
			}
		}),
		valueContainer: (provided) => ({
		  ...provided,
		  height: '2.25rem',
		  minHeight: '2rem',
		  padding: '0 8px', // Center the text vertically
		  display: 'flex',
		//   color: '#fff',
		  alignItems: 'center',
		  fontSize: '.9rem'
		}),
		input: (provided) => ({
		  ...provided,
		  height: '2.25rem',
		  minHeight: '2rem',
		  margin: '0', 
		  padding: '0',
		//   color: '#fff',
		  fontSize: '.9rem' 
		}),
		indicatorsContainer: (provided) => ({
		  ...provided,
		  height: '2.25rem',
		  display: 'flex',
		  alignItems: 'center',
		  padding:'.5rem',
		  paddingTop: '0',
		  paddingBottom: '0'
		}),
		dropdownIndicator: (provided) => ({
		  ...provided,
		  padding: '0', // Remove padding to center the icon
		  width: '1rem',
		  marginLeft: '.5rem',
		//   color: '#fff',
		  cursor: 'pointer',
		}),
		placeholder: (provided) => ({
		  ...provided,
		//   margin: '0',
		//   fontSize: '1em',
		//   color: '#fff',
		//   fontFamily: 'poppins'
	    }),
		menu: (provided) => ({
		  ...provided,
		//   borderRadius: '.1rem', // Adjust this value as needed
		}),
		singleValue: (provided) => ({
			...provided,
			// color: 'white', // Set selected option text color to white
		}),
	};

    const handleChange = (option) => {
        setSelectedOption(option)
    }

    const [sideNav, setSideNav] = useState(false)
    const handleSideNav = (state) => {
        setSideNav(state)
    }
    const [falseState, setFalseState] = useState(null)

    return (
        <div className='KitchenRegMainDiv'>
            <SherDineNav sideNav={(state) => handleSideNav(state)} falseState={falseState} />
            <div className='KitchenRegContentDiv flex gap-3'>
                <SideNav focus={'Menu'} state={sideNav} falseState={(state) => setFalseState(state)} />
                <div className='KitchenRegContentSideBarRight'>
                    <div className="KitchenRegSidebar">
                        <TopRootDiv image={'Menu Management'} root={['Menu Management', 'Base Menu']} section={'Add Kitchen'} />
                    </div>
                    <div className='Container_Menu KitchenRegForm flex flex-col h-full pt-3'>
                        <div className='TableAreaReg_areaDetails_span bg-white rounded-t-md border-b'>
                            <span>{subKitchen ? subKitchen : 'Sub Kitchen Details'}</span>
                            <div className=' AddItem_Buttons AddItem_Buttons_TableAreaReg text-nowrap'>
                                <button className='loginBorder text-[#0008B4] rounded-[.313rem] pt-1 pb-1 pl-3 pr-3' onClick={handleCancel}>Cancel</button>
                                <button className='loginBorder text-[#fff] bg-[#0008B4] rounded-[.313rem] pt-1 pb-1 pl-3 pr-3' onClick={handleSubmit}>Save</button>
                            </div>
                        </div>
                        {/* <div className='KitchenRegForm_Contents '> */}
                        <div className='KitchenRegForm_part p-4 bg-white flex-grow h-full rounded-b-md shadow-sm border border-t-0 border-gray-200'>
                            <div className='w-1/2 flex flex-col gap-1'>
                                <span>Sub Kitchen Name</span>
                                <input className="w-full p-2" type="text" value={SubKitchenName} onChange={handleSubKitchenNameChange} />
                            </div>
                            <div className="w-1/2 flex flex-col gap-1">
                                <span>Kitchen</span>
                                <div className='w-full'>
                                    <Select
                                        styles={customStyles}
                                        placeholder='Select...'
                                        value={selectedOption}
                                        options={options}
                                        onChange={(selectedOption) => handleChange(selectedOption)}
                                        // components={{ 
                                        // 	Option: CustomOption,
                                        // 	SingleValue: CustomSingleValue, 
                                        // 	Placeholder: CustomPlaceholder
                                        // }}
                                        // isDisabled={true}
                                        />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default SubKitchenReg
